import React, { FC, ReactNode } from 'react';
import { Entry } from 'contentful';
import {
  TypeLink_externalFields,
  TypeLink_internalFields,
  TypeAddToCartCtaFields,
  TypeAddToCartCta,
} from '@/core/generated-types';
import { CONTENT_TYPE_LINK, getContentType } from '@/core/constants';
import { ExternalLink, InternalLink } from '@/components/ui';
import { AddToCartCta } from '../AddToCartCta';
import { Overridable } from '../Overridable';

export type UniversalLinkFields =
  | TypeLink_externalFields
  | TypeLink_internalFields;

export interface UniversalLinkProps {
  classes?: string; // Append to the default classes
  overrideClasses?: string; // Override the default classes
  chevronClasses?: string;
  link?: Entry<UniversalLinkFields | TypeAddToCartCtaFields> | undefined;
  hideArrow?: boolean;
  children?: ReactNode;
  queryString?: string | undefined;
  onClick?: React.MouseEventHandler<any> | undefined;
  testId?: string;
}

const UniversalLink: FC<UniversalLinkProps> = (props) => {
  const { link, testId } = props;

  if (!link) {
    return null;
  }

  const contentType = getContentType(link);

  const linkContent = (() => {
    switch (contentType) {
      case CONTENT_TYPE_LINK.EXTERNAL:
        return <ExternalLink {...(props as any)} />;

      case CONTENT_TYPE_LINK.ADD_TO_CART:
        return (
          <AddToCartCta
            addToCartText={(link as TypeAddToCartCta).fields.addToCartText}
            testId={testId}
          />
        );

      default:
        return <InternalLink {...(props as any)} />;
    }
  })();

  return <Overridable content={link}>{linkContent}</Overridable>;
};

export default React.memo(UniversalLink);
